import {
    doc,
    setDoc,
    serverTimestamp
} from "firebase/firestore"
import { auth, db } from "../firebase"
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, sendEmailVerification, sendPasswordResetEmail } from "firebase/auth"
import { useNavigate } from "react-router-dom"
import { useState } from "react"
import {Tooltip} from 'react-tooltip' 
import AddressAutocompleteProvider from "./helperComponents/AddressAutocompleteProvider"
import { getAddressData } from "../helpers/HelperFunctions"

const LoginModal = ({onHide}) => {

    const [modalMode, setModalMode] = useState("login")
    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [birthday, setBirthday] = useState("")
    const [address, setAddress] = useState("")
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [passwordMatch, setPasswordMatch] = useState(true)
    const [passwordLength, setPasswordLength] = useState(true)
    const navigate = useNavigate()
    // const google = () => {
    //     window.open("http://localhost:5000/auth/google", "_self")
    // }

    // const facebook = () => {
    //     window.open("http://localhost:5000/auth/facebook", "_self")
    // }
    
    const handleLogin = async(e) => {
        e.preventDefault()
        const email=e.target[0].value
        const password = e.target[1].value

        try {
            const res = await signInWithEmailAndPassword(auth, email, password)
            console.log(res)
            navigate("/")
            navigate(0)
        } catch (err) {
            console.log(err)
            alert(err)
        }
    }

    // const actionCodeSettings = {
    //     // URL you want to redirect back to. The domain (www.example.com) for this
    //     // URL must be in the authorized domains list in the Firebase Console.
    //     url: 'http://localhost:3000/',
    //     // This must be true.
    //     handleCodeInApp: true,
    //     iOS: {
    //       bundleId: 'http://localhost:3000/'
    //     },
    //     android: {
    //       packageName: 'http://localhost:3000/'
    //     //   installApp: true,
    //     //   minimumVersion: '12'
    //     },
    //     dynamicLinkDomain: 'http://localhost:3000/'
    //   };
    
    const handleSubmit = async(e) => {
        e.preventDefault()
        if (password === confirmPassword && password.length >= 8 && confirmPassword.length >= 8) {
            try {
                await createUserWithEmailAndPassword(auth, email, password)
                    .then(async user => {
                        console.log(user, `created user ${user.user.uid}`)
                        const addressData = await getAddressData(address)
                        const updateUserData = {
                            // email: user.user.email,
                            firstName: firstName,
                            lastName: lastName,
                            // birthday: birthday,
                            // addressData: addressData,
                            // activeChats: {
                            //     buying: [],
                            //     selling: []    
                            // },
                            // activeBids: [],
                            activeListings: [],
                            uid: user.user.uid,
                            createdAt: serverTimestamp()
                        }
                        console.log(updateUserData)
                        await setDoc(doc(db, "users", user.user.uid), updateUserData)
                        await setDoc(
                            doc(db,`users/${user.user.uid}/private`, "data"),
                            {
                                email: user.user.email,
                                birthday: birthday,
                                addressData: addressData,
                                activeChats: [],
                                activeBids: [],
                                notificationSettings: {
                                    allMessagesEmailNotif: true,
                                    newChatEmailNotif: true
                                }
                            }
                        )
                        await sendEmailVerification(auth.currentUser)
                        .then(async () => {
                            alert("Email verification link sent")
                            await signInWithEmailAndPassword(auth, email, password)
                            navigate("/")
                            navigate(0)
                        })
                    })
            } catch (err) {
                console.log(err)
                alert(err)
            }
        } else {
            if (password !== confirmPassword) {
                setPasswordMatch(false)
            }
            if (password.length < 8 || confirmPassword.length < 8) {
                setPasswordLength(false)
            }
        }
    }


    const handlePasswordReset = async(e) => {
        e.preventDefault()
        const email=e.target[0].value
        try {
            await sendPasswordResetEmail(auth, email)
            alert("Password reset")
            window.location.reload()
        } catch (err) {
            console.log(err)
        }
    }
    
    const renderModal = (modalMode) => {
        if (modalMode === "login") {
            return (
                <div className="login-modal-container">
                    <h1>Log In</h1>
                    <form className="modal-form" onSubmit={handleLogin}>
                        <input className="form-input" type="text" placeholder="Username or E-mail"/>
                        <input className="form-input" type="password" placeholder="Password"/>
                        <button className="submit btn btn-primary">Login</button>
                    </form>
                    <span className="modal-anchor" onClick={() => setModalMode("pwreset")}>Forgot password?</span>
                    <span className="modal-text">New to Phreesh? <span className="modal-anchor" onClick={() => setModalMode("signup")}>Sign up!</span></span>
                    
                </div>
            )
        } else if (modalMode === "signup") {
            return (
                <div className="signUp">
                    <h1>Sign Up</h1>
                    {!passwordMatch && <div className='alert alert-danger'>Password confirmation does not match</div>}
                    {!passwordLength && <div className='alert alert-danger'>Password must be at least 8 characteres</div>}  
                    <form className="modal-form" onSubmit={handleSubmit}>
                        <div className="split-row">
                            <div className="column-form-input">
                                <div className="input-with-tooltip">
                                    <span>First Name*</span>    
                                    <span className="tooltip-helper" data-tooltip-id="first-name-tooltip">i</span>
                                </div>
                                <input className="form-input" type="text" onChange={e=> setFirstName(e.target.value)} required/>
                            </div>

                            <div className="column-form-input">
                                <div>Last Name</div>    
                                <input className="form-input" type="text" onChange={e=> setLastName(e.target.value)}/>
                            </div>
                        </div>
                        
                        {/* <div className="input-with-tooltip">
                            <span>Display Name*</span>    
                            <span className="tooltip-helper" data-tooltip-id="display-name-tooltip">i</span>
                        </div>
                        <input className="form-input" type="text" onChange={e=> setDisplayName(e.target.value)} required/> */}

                        <div className="split-row">
                            <div className="column-form-input">
                                <div>Birthday*</div>    
                                <input className="form-input" type="date" id="datePickerId" min="1900-01-01" 
                                    max={new Date().toISOString().split("T")[0]} 
                                    onChange={e=> setBirthday(e.target.value)}
                                required/>
                            </div>
                            
                            <div className="column-form-input">
                                <div className="input-with-tooltip">
                                    <span>Default Pick-up Location</span>    
                                    <span className="tooltip-helper" data-tooltip-id="address-tooltip">i</span>
                                </div>
                                {/* <input className="form-input" type="text" onChange={e=> setZipcode(e.target.value)}/> */}
                                <AddressAutocompleteProvider address={address} setAddress={setAddress}/>
                            </div>
                        </div>

                        <div>E-mail*</div>
                        <input className="form-input" type="email" onChange={e=> setEmail(e.target.value)}required/>
                        
                        <div>Password*</div>
                        <input className="form-input" type="password" onChange={e=> setPassword(e.target.value)} required/>
                        
                        <div>Confirm Password*</div>
                        <input className="form-input" type="password" onChange={e=> setConfirmPassword(e.target.value)} required/>
                        
                        <button className="submit btn btn-primary">Sign up</button>
                    </form>
                    <span className="modal-text">Already have an account? </span>
                    <span className="modal-anchor" onClick={() => setModalMode("login")}>Log In!</span>
                    <Tooltip id="first-name-tooltip" content="This will be the name others will see you as." place="right"/>
                    {/* <Tooltip id="display-name-tooltip" content="This will be the name others will see you as" place="right"/> */}
                    <Tooltip className="tooltip" id="address-tooltip" place="right" style={{display: 'flex', flexDirection: 'column'}}> 
                        <span>This will be the default location for your listings and the center of your map.</span>
                        <span>A full address or specific location will make the marker placed on the map more accurate!</span>
                    </Tooltip>
                </div>
            )
        } else if (modalMode === "pwreset") {
            return (
                <div className="right">
                    <h1>Reset Password</h1>
                    <form className="modal-form" onSubmit={handlePasswordReset}>
                        <input className="form-input" type="text" placeholder="E-mail"/>
                        <button className="submit btn btn-primary">Reset Password</button>
                    </form>
                    <span className="modal-anchor" onClick={() => setModalMode("login")}>Back to login</span>
                </div>
            )
        }
            
    }

    return (
        <div className="wrapper">
            {/* <div className="left">
                <div className="loginButton google" onClick={google}>
                    <img src="" alt="" />
                    Google
                </div>
                <div className="loginButton facebook" onClick={facebook}>
                    <img src="" alt="" />
                    Facebook
                </div>
            </div> */}
            {renderModal(modalMode)}                
        </div>
    )
}

export default LoginModal